import { AxiosHelper } from "../axiosConfig";
import APIConstant from "../utils/apiConstant";
export const getProfile = (token: string) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_Profile, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
